/** Codes shown in the Availability dropdown; `title` is native tooltip on hover. */
export const AVAILABILITY_OPTIONS = [
  { value: "PIA", title: "Parts is Available" },
  { value: "NLA", title: "No Longer Available" },
  { value: "NLO", title: "No Longer Orderable" },
  { value: "BORD", title: "Back Ordered" },
  { value: "NYA", title: "Not Yet Available" },
];

export function availabilityTooltipForCode(code) {
  if (code == null || String(code).trim() === "") return undefined;
  return AVAILABILITY_OPTIONS.find((o) => o.value === String(code).trim())
    ?.title;
}

export function formatPartAttributes(attrs) {
  if (!Array.isArray(attrs) || attrs.length === 0) return "-";
  return attrs
    .map((a) =>
      [a.attributeId, a.name, a.value, a.uom].filter(Boolean).join(", ")
    )
    .join("; ");
}

export function formatPartRestrictions(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return "-";
  return rows
    .map((r) =>
      [r.restrictionId, r.name, r.includeExcludeFlag].filter(Boolean).join(", ")
    )
    .join("; ");
}

/** Display "-" when empty (matches catalog editor table cells). */
export function cellText(v) {
  if (v == null) return "-";
  const t = String(v).trim();
  return t === "" ? "-" : t;
}
